/**
 * Formats a JavaScript Date object to a string based on the specified format.
 *
 * @param {Date|string} date - The date to format. Can be a Date object or a date string.
 * @param {string} format - The format string that specifies the order of day, month, and year.
 *                           Supported tokens: 'DD' for day, 'MM' for month, 'YYYY' for year.
 *                           Example format strings: 'DD-MM-YYYY', 'YYYY-MM-DD'
 * @returns {string} - The formatted date string.
 */
export function formatDate(date, format = 'YYYY-MM-DD') {
    if (!date) return '';

    // If date is a string, convert it to a Date object
    const d = typeof date === 'string' ? new Date(date) : date;

    // Ensure the input is a valid Date object
    if (isNaN(d.getTime())) return '';

    const year = d.getFullYear();
    const month = String(d.getMonth() + 1).padStart(2, '0');
    const day = String(d.getDate()).padStart(2, '0');

    // Replace format tokens with actual date values
    return format
        .replace('YYYY', year)
        .replace('MM', month)
        .replace('DD', day);
}
